import { TextBody } from '@ally/metronome-ui';

const AccordionFooterComponent = (content: React.ReactNode): JSX.Element => {
  return (
    <TextBody tag='p' size='md'>
      {content}
    </TextBody>
  );
};

export default AccordionFooterComponent;
